import profile1 from "../../assets/profile_1.png";
import profile2 from "../../assets/profile_2.png";
import profile3 from "../../assets/profile_3.png";
import profile4 from "../../assets/profile_4.png";
import profile5 from "../../assets/profile_5.png";
export const Accordianlist = [
    {
        "jobId": 1109,
        "firstName": 'Anna',
        "lastName": "Johennasberg",
        "rating": '4.2',
        "review": '12',
        "distance":'2.5 Km',
        "executionDate": '2/11/2022',
        "time": '9:30 am',
        "createdOn": "2/11/2022",
        "profile": profile1
    },
    {
        "jobId": 1109,
        "firstName": 'Anna',
        "lastName": "Johennasberg",
        "rating": '4.2',
        "review": '12',
        "distance":'2.5 Km',
        "executionDate": '2/11/2022',
        "time": '9:30 am',
        "createdOn": "2/11/2022",
        "profile": profile2
    },

    {
        "jobId": 1109,
        "firstName": 'Anna',
        "lastName": "Johennasberg",
        "rating": '4.2',
        "review": '12',
        "distance":'2.5 Km',
        "executionDate": '2/11/2022',
        "time": '9:30 am',
        "createdOn": "2/11/2022",
        "profile": profile3
    },
    {
        "jobId": 1109,
        "firstName": 'Anna',
        "lastName": "Johennasberg",
        "distance":'2.5 Km',
        "rating": '4.2',
        "review": '12',
        "executionDate": '2/11/2022',
        "time": '9:30 am',
        "createdOn": "2/11/2022",
        "profile": profile4
    },
    {
        "jobId": 1109,
        "firstName": 'Anna',
        "lastName": "Johennasberg",
        "rating": '4.2',
        "review": '12',
        "distance":'2.5 Km',
        "executionDate": '2/11/2022',
        "time": '9:30 am',
        "createdOn": "2/11/2022",
        "profile": profile5

    }

]

export const JobDetailsList = [
    {
        "jobId": 1109,
        "jobCategory": 'Water Tank and Motor Repair',
        "service" : "Motor leakage",
    }, 
    {
        "jobId": 1109,
        "jobCategory": 'Toilet Drain',
        "service" : "Motor leakage",
    }, 
]

export const jobStatusList = [
    { 'value': 'Submitted', 'label': 'Submitted'},
    { 'value': 'Approved', 'label': 'Approved'},
    { 'value': 'On Hold', 'label': 'On Hold' },
    { 'value': 'Rejected', 'label': 'Rejected' },
    { 'value': 'With Qualification', 'label': 'With Qualification' }
   
]